module.exports = __webpack_public_path__ + "static/media/logout.99dab373.svg";